import React, { Fragment} from "react";

const Encabezado =(props)=> {
    return (
        <Fragment>
            <div className="row justify-content-center">
                <div className="col-12 col-sm-11  text-center m-4 ">
                    <img
                        className="img-fluid logo"
                        alt="Logo"
                        src={props.election.configuration.logo_url}
                    />
                </div>
            </div>
            <div className="row justify-content-center">
                <div className="col-12 col-sm-11 text-center">
                    <h2 className="font-weight-bold">{props.election.name}</h2>
                    <h3 className="font-italic">{props.election.organization_name}</h3>
                    <br/>
                    <h5><b>¡IMPORTANTE!</b></h5>
                    <h5><b>Horario de votación:</b></h5>
                    <h5>Sábado 14: de 09:00 a 18:00 hrs Perú.</h5>
                    <h5>Domingo 15: de 09:00 a 18:00 hrs Perú.</h5>
                    <br/>
                    <h5><b>Sobre el carnet de extranjeria:</b></h5>
                    <h5>Los asociados que <b>NO cuenten con DNI</b> y solo tengan Carnet de Extranjería, podrán colocar el número del CE en el campo de DNI sin que ello afecte su derecho a voto.</h5>
                </div>
            </div>
        </Fragment>
    )
}

export default Encabezado;